import { atomWithKey as atom } from "./atomWithKey";

export interface SelectedShuttleData {
  shuttle: any;
  trip: any;
  stationId: string;
  trainType: 'outbound' | 'inbound';
  position: 'before' | 'after';
  offerId?: string;
}

export interface SelectedShuttlesState {
  [key: string]: SelectedShuttleData;
}

export const selectedShuttlesAtom = atom<SelectedShuttlesState>({
  key: "selectedShuttlesAtom",
  default: {},
});
